import React from 'react';

//components
import { Cpds } from '@Cpds.Ui';
import { HeroVideoController } from '../styles/v3-brand-artcile-hero-module-style';

//typings
import { customControlProps } from 'src/components/common/modules/video-player/video';

const customVideoController: React.FC<customControlProps> = (props) => {
  const { isPlaying, togglePlay } = props;

  return (
    <HeroVideoController onClick={togglePlay}>
      {isPlaying ? (
        <Cpds.Icon id="pause-filled" name="pause-filled" size="medium" />
      ) : (
        <Cpds.Icon id="play-filled" name="play-filled" size="medium" />
      )}
    </HeroVideoController>
  );
};

export default customVideoController;
